import { render, staticRenderFns } from "./CaseDetailPanel.vue?vue&type=template&id=c5f4a716&scoped=true&"
import script from "./CaseDetailPanel.vue?vue&type=script&lang=js&"
export * from "./CaseDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetailPanel.vue?vue&type=style&index=0&id=c5f4a716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f4a716",
  null
  
)

export default component.exports